import { render, staticRenderFns } from "./LoyaltyTiers.vue?vue&type=template&id=997f059c&"
import script from "./LoyaltyTiers.vue?vue&type=script&lang=js&"
export * from "./LoyaltyTiers.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyTiers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports